import React, { useState, useContext } from 'react';
import { useSelector } from 'react-redux';
import { Space, Button } from 'antd';
import ParentContext from 'pages/Noc/Threshold/context';
import { adminRoleSelector, unsavedThresholdSelector } from '@store/noc/base/selectors';
import { tid } from '@utils/test';
import { SummaryWrapper } from '../../styled';
import ActionPopover from '../../ActionPopover';
import Actions from './PopoverContent/Actions';
import PromptModal from './PromptModal';

interface IProps {
  setView(view: string): string;
  callback?: () => void;
}

// eslint-disable-next-line react/display-name
export default ({ setView, callback }: IProps) => {
  const parentContext = useContext(ParentContext);
  const { hasError } = parentContext;
  const [showUnsavedDataWarning, setShowUnsavedDataWarning] = useState(false);

  const isAdmin = useSelector(adminRoleSelector);
  const unsavedChanges = useSelector(unsavedThresholdSelector);

  const navigateToNoc = () => {
    if (!unsavedChanges) {
      setView('noc');
    } else {
      setShowUnsavedDataWarning(true);
    }
  };

  return (
    <SummaryWrapper {...tid('controls')}>
      <PromptModal
        showUnsavedDataWarning={showUnsavedDataWarning}
        setShowUnsavedDataWarning={setShowUnsavedDataWarning}
      />
      <Space>
        <Button onClick={navigateToNoc} disabled={hasError}>
          View Dashboard
        </Button>
        {isAdmin && (
          <ActionPopover zIndex={1}>
            <Actions callback={callback} />
          </ActionPopover>
        )}
      </Space>
    </SummaryWrapper>
  );
};
